import { formatDate, formatMoney } from '@pms/shared';

export const money = (v: string | number | null | undefined, currency = 'NGN') => (v === null || v === undefined ? '—' : formatMoney(v, currency));
export const date = (d: string | null | undefined, style: 'short' | 'long' = 'short') => (d ? formatDate(d.slice(0, 10), style) : '—');
export const dateTime = (iso: string | null | undefined) =>
  iso ? new Intl.DateTimeFormat('en-GB', { timeZone: 'Africa/Lagos', day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }).format(new Date(iso)) : '—';
/** Hotel-time hour and minute, e.g. "14:05". */
export const clock = (iso: string | null | undefined) =>
  iso ? new Intl.DateTimeFormat('en-GB', { timeZone: 'Africa/Lagos', hour: '2-digit', minute: '2-digit' }).format(new Date(iso)) : '—';
/** "just now", "12 min ago", "2 h 5 min ago". */
export const ago = (iso: string | null | undefined, now = Date.now()) => {
  if (!iso) return '';
  const m = Math.max(0, Math.round((now - Date.parse(iso)) / 60_000));
  return m < 1 ? 'just now' : m < 60 ? `${m} min ago` : `${Math.floor(m / 60)} h ${m % 60} min ago`;
};
export const titleCase = (s: string) => s.toLowerCase().replace(/(^|[_\s])(\w)/g, (_m, sep: string, c: string) => (sep ? ' ' : '') + c.toUpperCase());
export const plural = (n: number, word: string) => `${n} ${word}${n === 1 ? '' : 's'}`;

export function cls(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}
